import React, { useState } from "react";
import "./styles.css";
import fileIcon from "../../../Assets/Icons/save.png";
import chatProfile from "../../../Assets/Images/patient-profile-img.png";
import Button from "../Buttons/Button";
import { sendMessageToPatient } from "../../../Services";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";

const ChatEdit = ({ handleNewMessage }) => {
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();

  const [message, setMessage] = useState([]);

  const sendMessage = async () => {
    try {
      const newMessageResponse = await sendMessageToPatient(
        physician.physician._id,
        patientId,
        { message: message }
      );
      if (!newMessageResponse.error) {
        setMessage("");
        handleNewMessage(newMessageResponse.data);
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  return (
    <div className="chat-edit">
      <div className="profile-img white" style={{ minWidth: "35px" }}>
        {" "}
        <h5 className="h5-400">
          {`${physician.firstName[0] || physician.lastName[0]}`}
        </h5>
      </div>
      <textarea
        rows={3}
        placeholder="enter message"
        style={{
          width: "90%",
          resize: "none",
          outline: "none",
          border: "1px solid #E9EBF0",
          borderRadius: "6px",
          padding: "10px",
          fontSize: "15px",
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      {/* <button className="chatedit-button">
        <img src={fileIcon} alt="fileicon" style={{ height: "15px", width: "15px"}}/> Save
      </button> */}
      <Button btnType={"send"} onClick={sendMessage}></Button>
    </div>
  );
};

export default ChatEdit;
